export default "__VITE_ASSET__3K0McYSR__"